module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('filter-orders'), _vm._v(" "), (_vm.orders.length) ? _c('table', {
    staticClass: "ls-table ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('orders.attributes.transaction')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('orders.attributes.contract')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('orders.attributes.status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('orders.attributes.customer')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('orders.attributes.payment_method_type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('orders.attributes.price')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(order.id) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.date.parseDate(order.created_at)) + "\n          ")]), _vm._v(" "), _c('td', [_c('authorized-link', {
      attrs: {
        "tag": "show_invoice"
      }
    }, [_vm._v("\n              #ID Fatura:\n              "), _c('router-link', {
      attrs: {
        "to": {
          name: 'invoice_details',
          params: {
            invoice_id: order.invoice_token
          }
        }
      }
    }, [_vm._v(_vm._s(order.invoice_id))])], 1), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('orders.attributes.contract_code')) + ": " + _vm._s(order.contract_code) + "\n          ")], 1), _vm._v(" "), _c('td', {
      class: _vm.mountTag(order.status)
    }, [_c('div', [_vm._v("\n              " + _vm._s(_vm.$t('orders.status.' + order.status)) + "\n            ")])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(order.customer.name)), _c('br'), _vm._v("\n            " + _vm._s(order.customer.email) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$t('orders.type.' + order.payment_method_type)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            R$ " + _vm._s(_vm.money.parseViewValue(order.price)) + "\n          ")])])
  }))]) : _c('div', {
    attrs: {
      "role": "alert"
    }
  }, [_c('empty-list')], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "updater": _vm.loadOrders
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9f3fe3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/orders/Main.vue
// module id = 841
// module chunks = 1